<template>
    <div class="flex items-center justify-center space-x-2 mt-6">
      <!-- Previous Button -->
      <button
        :disabled="currentPage === 1"
        @click="changePage(currentPage - 1)"
        class="px-3 py-2 rounded-md bg-gray-200 hover:bg-gray-300 disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed"
      >
        Previous
      </button>
  
      <!-- Page Numbers -->
      <button
        v-for="page in visiblePages"
        :key="page"
        @click="changePage(page)"
        :class="[
          'px-3 py-2 rounded-md',
          page === currentPage ? 'bg-blue-500 text-white' : 'bg-gray-200 hover:bg-gray-300'
        ]"
        :disabled="page === '...' || page === currentPage"
      >
        {{ page }}
      </button>
  
      <!-- Next Button -->
      <button
        :disabled="currentPage === totalPages"
        @click="changePage(currentPage + 1)"
        class="px-3 py-2 rounded-md bg-gray-200 hover:bg-gray-300 disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed"
      >
        Next
      </button>
    </div>
  </template>
  
  <script>
  export default {
    name: "BasePagination",
    props: {
      totalItems: {
        type: Number,
        required: true,
      },
      itemsPerPage: {
        type: Number,
        default: 10,
      },
      currentPage: {
        type: Number,
        default: 1,
      },
    },
    emits: ["page-changed"],
    computed: {
      totalPages() {
        return Math.ceil(this.totalItems / this.itemsPerPage);
      },
      visiblePages() {
        const total = this.totalPages;
        const current = this.currentPage;
  
        if (total <= 10) {
          // If total pages <= 10, show all pages
          return Array.from({ length: total }, (_, i) => i + 1);
        }
  
        const pages = [];
  
        // Always show the first page
        pages.push(1);
  
        // Show ellipsis before current range if currentPage > 4
        if (current > 4) {
          pages.push("...");
        }
  
        // Show up to 3 pages before the current page
        const start = Math.max(2, current - 2);
        const end = Math.min(total - 1, current + 2);
  
        for (let i = start; i <= end; i++) {
          pages.push(i);
        }
  
        // Show ellipsis after current range if currentPage < totalPages - 3
        if (current < total - 3) {
          pages.push("...");
        }
  
        // Always show the last page
        pages.push(total);
  
        return pages;
      },
    },
    methods: {
      changePage(page) {
        if (page !== this.currentPage && page !== "...") {
          this.$emit("page-changed", page);
        }
      },
    },
  };
  </script>
  
  <style scoped>
  button:focus {
    outline: none;
  }
  </style>